// src/components/Header/Header.tsx
import React, { useEffect, useState } from 'react';
import styles from './Hero.module.css';
import { useTranslation } from 'react-i18next';
const Hero: React.FC = () => {
  const { t, i18n } = useTranslation();

  const [currentIndex, setCurrentIndex] = useState(0);
  const texts = [t('carottagePro'), t('serviceProfessionnel'), t('interventionRapide')];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % 3);
    }, 4000); // Switch every 3 seconds

    return () => clearInterval(interval);
  }, []);


  return (
    <div className={styles.sectionContainer} id='/'>
      <div className={styles.heroSection}>
        <div className={styles.textSection}>

          <h1 className={`${styles.textTitle} ${i18n.language === 'ar' ? styles.arabic : ''
            }`} >
            {t('expertCarottage')}
          </h1>
          <div className={styles.textDescritpion}>
            <p className={i18n.language === 'ar' ? styles.arabic : ''}>
              {t('expertCarottageDescription')}
            </p>
            <br />
            <div className={`${styles.typewriter} ${i18n.language === 'ar' ? styles.arabic : ''
              }`}>

              <p key={texts[currentIndex]} className={i18n.language === 'ar' ? styles.arabic : ''}>
                {texts[currentIndex]}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

  );
}

export default Hero;
